var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-direction":"row"}},[_c('kendo-colorpicker',{ref:'colorPickerRef',attrs:{"id":'colorPickerId',"palette":_vm.paletteArray}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }